import {apiMethods} from "../../controller/Request";
import {Config} from "../../controller/Global";


export const WasteProfileGet = (id, params = {}) => {
  const URL = Config['api']['tracks']['waste_profile']['get'] + id + '/';
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })
};
export const WasteProfileList = (params = {}) => {
  const URL = Config['api']['tracks']['waste_profile']['list'];
  return apiMethods.get(URL, params, true)
    .then(response => {
      return response
    })

};
export const WasteProfilePost = (params = {}, headers=null, formData=false) => {
  const URL = Config['api']['tracks']['waste_profile']['post'];
  return apiMethods.post(URL, formData? params : JSON.stringify(params), true, headers)
    .then(response => {
      return response
    })

};
export const WasteProfileUpdate = (id, params = {}) => {
  const URL = Config['api']['tracks']['waste_profile']['put'] + id + '/';
  return apiMethods.put(URL, JSON.stringify(params), true)
    .then(response => {
      return response
    })
};

export const WasteProfileRemove = (id, params = {}) => {
  const URL = Config['api']['tracks']['waste_profile']['delete'] + id + "/";
  return apiMethods.remove(URL, params, true)
    .then(response => {
      return response
    })
};

export const WasteProfilePDF = (id, params = {}) => {
  const URL = Config['api']['pdf']['waste_profile']['get'] + id + '/';
   return apiMethods.getPDF(URL, params, true)
  .then(response => {
      return response
    })
};


// WEBPACK FOOTER //
// ./src/models/waste_profile/wasteProfile.jsx